import React, { Component } from 'react';
import Select from 'react-select';
import {Button,Row,Col} from 'reactstrap';
import {staticTitles} from '../../../utils/constants';

class PickOffice extends Component {

  state = {error : ''}

  handleNextStep = () => {
    const {selectedFlaggedAdminOffice} = this.props;
    if(selectedFlaggedAdminOffice) {
      this.setState({
        error : ''
      })
      this.props.nextStep();
    } else {
      this.setState({
        error : 'Please select an office.'
      })
    }
  }

  renderOfficePaths = (option) => {
    let target = `${option.code}${this.props.index}`;
    // console.log(option);
    return (
      <div>
        <div>
          {option.value}
        </div>
        <div style={{fontSize:'12px',color:'#A5A6AC'}}>
          {option.path}
        </div>
      </div>
    )
  }

  render() { 
    const {allOffices,allOfficeMaterialPaths,selectedFlaggedAdminOffice} = this.props;
    const options = allOffices.map((office) => {
      const option = {};
      option.label = office.officeName;
      option.value = office.officeName;
      option.path = office.officePath.replace(/#/g,' > ');
      return option;
    })
    const {error} = this.state;
    return ( 
      <div>
        <div className="item-subheader">
        As the Enterprise Admin, please select the highest office in the organizational hierarchy to assign 
        yourself to. This will give you access to all of the Enterprise Analytics and {staticTitles.toolkit_lg} information.
        </div>
        <div className="row mt40">
          <div className="col-md-offset-1 col-lg-offset-1 col-md-3 col-lg-3 chartLabel" style={{textAlign: 'right'}}>
            Select your office
          </div>
          <div className="col-lg-5 col-md-5">
            <Select 
              onChange={this.props.flaggedAdminOfficeSelected}
              name="role" 
              options={options}
              optionRenderer={this.renderOfficePaths}
              value={selectedFlaggedAdminOffice}
              placeholder={"Select office from the list"}
              />
          </div>
        </div>
        {
          error.length > 0 ? 
          <div className="row mt10">
            <div className="offset-md-3 offset-lg-3 col-md-5 col-lg-5 map-gender-err-msg">
              {error}
            </div>
          </div> : null
        }
        <Row className="mt40 mb10 clearfix">
          <Col sm={{ size: '6' }} style={{ padding:'0' }}>
            <Col sm={{ size: '6' }}>
              <Button
                className="float-left goBackBtn w100"
                onClick={this.props.goBack}>
                <span className="cancelBtnTxt">
                  <span className="ml10 flaticon-back" /> Go Back
                </span>
              </Button>
            </Col>
          </Col>
          <Col sm={{ size: '6' }} style={{ padding:'0' }}>
            <Col sm={{ size: '6', offset: 6 }}>
              <Button
                className="float-right continueBtn ml10 w100"
                onClick={this.handleNextStep}>
                <span className="continueBtnTxt">
                  Continue <span className="ml10 flaticon-next" />
                </span>
              </Button>
            </Col>
          </Col>
        </Row>
      </div>
    );
  }
}
 
export default PickOffice;